import axios from "axios";
import React, { useState, useEffect } from "react";
import { apiKey } from "../../config/config";
import { toast } from "react-toastify";

function KitchenCard({ order, fetchData }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [orderTime, setOrderTime] = useState("");

  // ⏳ Calculate elapsed time
  useEffect(() => {
    const updateTime = () => {
      const createdAt = new Date(order.created_at);
      const now = new Date();
      const diffMs = now - createdAt;

      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
      const seconds = Math.floor((diffMs / 1000) % 60);

      setOrderTime(
        `${hours / 10 < 1 ? "0" : ""}${hours}:${
          minutes / 10 < 1 ? "0" : ""
        }${minutes}:${seconds / 10 < 1 ? "0" : ""}${seconds}`
      );
    };

    updateTime(); // run once immediately
    const interval = setInterval(updateTime, 1000); // update every second

    return () => clearInterval(interval); // cleanup on unmount
  }, [order.created_at]);

  const handleSelectOrder = (item) => {
    // Prevent selecting if already ready
    if (item.cooking_status === "ready") return;

    setSelectedOrders((prev) =>
      prev.find((oldItem) => oldItem.id === item.id)
        ? prev.filter((oldItem) => oldItem.id !== item.id)
        : [...prev, item]
    );
  };

  const handleSelectAll = () => {
    // Only select items that are not ready
    setSelectedOrders(
      order.order_details.filter((item) => item.cooking_status !== "ready")
    );
  };

  const handleUnselectAll = () => {
    setSelectedOrders([]);
  };

  const handleCooking = (status) => {
    let data = selectedOrders.map((item) => ({
      id: item.id,
      cooking_status: status,
    }));

    if (data.length === 0 || status === "") {
      return;
    }

    axios
      .put(
        `${apiKey}/api/rms/admin/kitchen/update-item-status`,
        {
          order_id: order.id,
          order_details: data,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((response) => {
        fetchData();
        setSelectedOrders([]);
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response?.data.message || "Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  return (
    <div className="h-96 border-2 border-d-bg bg-white border-dashed m-4 rounded-md shadow-lg relative flex flex-col">
      <div className="bg-d-bg p-2 w-full flex justify-between text-white text-sm">
        <div>
          <h5 className="text-white">Invoice: {order.sale_no}</h5>
          <h5 className="text-white">Table: {order?.table?.name}</h5>
        </div>
        <div>
          <span className="p-1 rounded bg-yellow-500">{orderTime}</span>
        </div>
      </div>
      <div className="flex-grow overflow-y-auto">
        {order.order_details?.map((item, idx) => {
          const isSelected = selectedOrders.find(
            (selected) => selected.id === item.id
          );

          let statusClass = "";
          if (item.cooking_status === "pending") {
            statusClass = "";
          } else if (item.cooking_status === "started") {
            statusClass = "bg-d-bg text-white";
          } else if (item.cooking_status === "ready") {
            statusClass = "bg-green-600 text-white cursor-not-allowed";
          }

          return (
            <div
              className={`p-2 text-sm flex justify-between cursor-pointer ${
                isSelected ? "bg-blue-100" : statusClass
              }`}
              onClick={() => handleSelectOrder(item)}
              key={idx}
            >
              <div>
                <div>{item.name}</div>
                <div className="font-semibold">Qty: {item.qty}</div>
              </div>
              <div>
                {item.cooking_status === "pending"
                  ? "Not Ready"
                  : item.cooking_status === "started"
                  ? "In Preparation"
                  : "Ready"}
              </div>
            </div>
          );
        })}
      </div>
      <div className="bg-gray-100 p-2 text-xs flex gap-2">
        <button onClick={handleSelectAll}>Select All</button>
        <button onClick={handleUnselectAll}>Unselect All</button>
        <button onClick={() => handleCooking("started")}>Cook</button>
        <button onClick={() => handleCooking("ready")}>Ready</button>
      </div>
    </div>
  );
}

export default KitchenCard;
